window.addEventListener("load", function () {
    if ( document.querySelectorAll('.historyElement').length ) {
        const buttons = document.querySelectorAll('.historyElement .linkBox');

        // Die erste .timelineSection beim Laden automatisch öffnen
        const firstTimelineSection = document.querySelector('.historyElement .timelineSection');
        if (firstTimelineSection) {
            firstTimelineSection.classList.add('open');
            const firstButton = firstTimelineSection.querySelector('.linkBox span');
            if (firstButton) {
                firstButton.textContent = "Chronik schließen";
            }
        }

        // Event Listener für die Buttons hinzufügen
        buttons.forEach(button => {
            button.addEventListener("click", function () {
                // Nächsthöheres Eltern-Element mit der Klasse 'timelineSection' finden
                const timelineSection = this.closest('.timelineSection');

                if (timelineSection) {
                    // Toggle-Klasse 'open' hinzufügen oder entfernen
                    const isOpen = timelineSection.classList.toggle('open');

                    // Button-Text ändern basierend auf dem Zustand
                    const buttonText = this.querySelector('span');
                    if (buttonText) {
                        buttonText.textContent = isOpen ? "Chronik schließen" : "Chronik öffnen";
                    }
                }
            });
        });

    }
});
